import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { SearchPayload } from "../../../search/SearchPayload"

class Service {
    async GetContacts(searchParams: SearchPayload) {
        try {
            return await AppContext.getApiClient().post("/listing/search", searchParams)
        } catch (err) {
            throw new Error("Error fetching 'listing/search' contacts")
        }
    }
}

const instance = new Service()
export default instance




// WEBPACK FOOTER //
// ./src/state/listing/contact/services/service.ts